"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKFLOW_REJECTED = exports.WORKFLOW_APPROVED = exports.UPDATE_ACTIVITY_OBJECT_COMMAND = exports.UPDATE_ACTIVITY_TEMPLATE_CONTENT_COMMAND = exports.WS_INTERNAL_FEED_ACTIVITY_CREATED = exports.WS_PUBLIC_FEED_ACTIVITY_CREATED = exports.FEED_ACTIVITY_CREATED = exports.CREATE_ACTIVITY_COMMAND = void 0;
exports.CREATE_ACTIVITY_COMMAND = 'create-activity';
exports.FEED_ACTIVITY_CREATED = 'feed-activity-created';
exports.WS_PUBLIC_FEED_ACTIVITY_CREATED = 'ws-public-feed-activity-created';
exports.WS_INTERNAL_FEED_ACTIVITY_CREATED = 'ws-internal-feed-activity-created';
exports.UPDATE_ACTIVITY_TEMPLATE_CONTENT_COMMAND = 'update-activity-template-content';
exports.UPDATE_ACTIVITY_OBJECT_COMMAND = 'update-activity-object';
exports.WORKFLOW_APPROVED = 'workflow-approved';
exports.WORKFLOW_REJECTED = 'workflow-rejected';
//# sourceMappingURL=event.type.js.map